import { Button, Divider, Flex, Space, Spin } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'src/styles/theme';
import { IDocument } from 'src/types/documents.types';
import { formatDate } from 'src/utils/dates';

import classes from './style/Card.module.css';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ICardProps {
  exa?: string;
  doc: IDocument;
  docType: string;
  downloadPdf: (doc: IDocument, docType: string) => Promise<void>;
}

const Card: React.FunctionComponent<ICardProps> = (props) => {
  const { doc, downloadPdf, docType } = props;
  // TOOLS
  const theme = useTheme();
  const { t } = useTranslation();
  const gradientList = [
    'linear-gradient(192.95deg, #216CFF -3.69%, #5215FF 150.37%)',
    'linear-gradient(192.95deg, #7521FF -3.69%, #EC15FF 150.37%)',
    'linear-gradient(192.95deg, #21FFAF -3.69%, #15ABFF 150.37%)',
    'linear-gradient(357.27deg, #FF21B3 -26.21%, #FF7715 123.4%)'
  ];

  const [loading, setLoading] = useState(false);

  const handleDownload = async (doc: IDocument) => {
    setLoading(true);
    try {
      await downloadPdf(doc, docType);
    } finally {
      setLoading(false);
    }
  };
  // VIEW
  return (
    <Flex vertical className={classes.cardMainFlex}>
      <Flex justify="flex-start">
        <Space>
          <div
            className={classes.gradient}
            style={{
              background:
                gradientList[Math.floor(Math.random() * gradientList.length)]
            }}
          ></div>
          <p
            className={`${theme.fonts.classNames.cardSubtitle} ${classes.dateText}`}
          >
            {formatDate(doc.docDate)}
          </p>
          <p
            className={`${theme.fonts.classNames.cardTitle} ${classes.docName}`}
          >
            {doc.docName}
          </p>
          {doc.isNew && (
            <Flex className={classes.badge} align="center">
              <span>{t('common.new')}</span>
            </Flex>
          )}
        </Space>
      </Flex>
      <Divider></Divider>
      <Flex justify="space-between" align="center">
        <Flex align="center" className={classes.wardDesc}>
          <p className={`${theme.fonts.classNames.cardSubtitle}`}>
            {doc.wardDesc}
          </p>
        </Flex>
        <Flex align="center">
          <Button
            className={classes.downloadButton}
            onClick={() => handleDownload(doc)}
          >
            {loading ? (
              <Spin />
            ) : (
              <img
                src="/assets/icons/downloadPdf.png"
                alt="Download PDF"
                className={classes.downloadImg}
              />
            )}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Card;
